import { AsyncPipe } from '@angular/common';
import { Component, OnDestroy, OnInit, inject } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { MultiOrderConsentComponent } from '@zero/shared/ui-web-components';
import { MultiOrderBaseComponent } from '@zero/trade/feature-trade/base';
import { filter } from 'rxjs';
import { MultiOrderConfirmComponent } from '../multi-order-confirm/multi-order-confirm.component';
import { MultiOrderCreateComponent } from '../multi-order-create/multi-order-create.component';
import { MultiOrderSuccessComponent } from '../multi-order-success/multi-order-success.component';

@Component({
  selector: 'trade-multi-order',
  imports: [AsyncPipe, MultiOrderCreateComponent, MultiOrderConfirmComponent, MultiOrderSuccessComponent],
  templateUrl: './multi-order.component.html',
})
export class MultiOrderComponent extends MultiOrderBaseComponent implements OnInit, OnDestroy {
  readonly #ngbModal = inject(NgbModal);

  async ngOnInit() {
    await this.facade.initMultiOrder();
    this.#listenToMultiOrderConsent();
    this.listenToQueryParams();
  }

  ngOnDestroy() {
    this.facade.clearMultiOrder();
  }

  readonly #listenToMultiOrderConsent = () => {
    this.facade.shouldDisplayMultiOrderConsent$
      .pipe(
        filter((shouldDisplayMultiOrderConsent) => !!shouldDisplayMultiOrderConsent),
        takeUntilDestroyed(this.destroyRef),
      )
      .subscribe(() =>
        this.#ngbModal.open(MultiOrderConsentComponent, { centered: true, size: 'lg', backdrop: 'static', keyboard: false }),
      );
  };
}
